import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router";
import {inject, observer} from "mobx-react";
import {Image} from "react-bootstrap";
import logo from "../img/official_logo.svg";
import LoadingAnimation from "./LoadingAnimation";

const AuthenticateUser = ({userStore, appStatusStore, children, allowOffline}) => {

  const {isAuthorized, ready: isAuthReady} = userStore;
  const {serverOffline: offline} = appStatusStore;
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    //console.debug(`auth ${isAuthenticated} ${isAuthorized} ${offline}`);
    if (offline === true) {
      if (!allowOffline) {
        navigate("/maintenance", {replace: true, state: {from: location}});
      }
    }
    else if (isAuthReady) {
      if (isAuthorized === false) {
        if (!/^\/(registration|register|signin|verify|changepass|resetpass)/.test(location.pathname)) {
          navigate("/signin", {
            replace: true,
            state: { from: location }
          });
        }
      }
    }
  }, [isAuthorized, isAuthReady, offline]);

  //const message = "Restoring session...";
  const message = "";
  return isAuthorized ? (
    <React.Fragment>{children}</React.Fragment>
  ) : (
    <div className="authorizing-placeholder">
      <Image src={logo} className="logo"/>
      <div>{message}</div>
      <LoadingAnimation />
    </div>
  );
}

const AuthWrapper = inject("userStore", "appStatusStore")(observer(AuthenticateUser));

export const withAuthentication = (WrappedComponent, allowOffline = false) =>
  (props) => (<AuthWrapper allowOffline={allowOffline}> <WrappedComponent {...props} /> </AuthWrapper>);

